<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="currentTab" :isMType="isMType"></ProductHeader>
    <div class="page-main">
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-result
            status="success"
            title="发布成功"
            sub-title="已同步将商品推送至云仓平台，可前往：云仓-我的主页-我供应的，操作手动推送、移除商品或设置自动推送。 "
          >
            <template #extra>
              <a-button key="console" type="primary" @click="goProList">返回列表</a-button>
              <a-button key="buy1" @click="onPreview">查看商品</a-button>
              <a-button key="buy2" @click="toEditor(proId,catalogId,proSource)">继续发布</a-button>
            </template>
          </a-result>
        </a-card>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from './ProductHeader'
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'SucceedPage',
  components: {
    ProductHeader
  },
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      merchantId: this.$store.getters.userInfo.merchantId,
      currentTab: 2,
      isMType: this.$route.query.isMType
    }
  },
  mounted() {
    this.currentTab = (this.catalogId == 73 || this.catalogId == 74) ? 4 : 2
  },
  methods: {
    goProList() {
      this.$router.push({
        name: 'GoodsList'
      })
    },
    //编辑
    toEditor(proId, catalogId, proSource) {
      let name = ''
      if (catalogId == 1) {
        name = 'TicketsBasicInfo'
      } else if (catalogId == 2) {
        name = 'HotelBasicInfo'
      } else if (catalogId == 3) {
        name = 'VisaBasicInfo'
      } else if (catalogId == 4) {
        name = 'ScenicHotelBasicInfo'
      } else if (catalogId == 5) {
        name = 'DepartmentBasicInfo'
      } else if (catalogId == 8) {
        name = 'PresellBasicInfo'
      } else if (catalogId == 75) {
        name = 'TravelBasicInfo'
      } else {
        name = 'TourBasicInfo'
      }
      this.$router.push({
        name,
        query: {
          proId: 0,
          catalogId: catalogId,
          proSource: 0
        }
      })
      // window.open(Logistics.href, '_blank');
      // SkipOtherHelper.toEditProduct(record.proId, record.proType)
    },
    //预览手机页面的详情
    onPreview() {
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      const params = {
        p: `${character}_${merchantId}_${merchantId}`
      }
      let domainUrl = this.$store.getters.platformConfig.h5Url
      RouterSwitchHelper.toProductDetails(domainUrl, this.proId, this.catalogId, 0, params)
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      flex: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.mr5 {
  margin-right: 5px;
}
</style>